<template>
  <div class="contentDetails">
    <NavBar :navBlock='navBlock' :navtitle='navtitle' :pageBack='true'></NavBar>
    <div class="detailsContent">
      <Goods :type='type'></Goods>
    </div>
  </div>
</template>

<script>
import NavBar from '@/components/navBar'
import Goods from '@/components/goods'
export default {
  data () {
    return {
      navBlock: '商城  /  商城列表',
      navtitle:'新增商品',
      type:'add',
    }
  },
  components: {
    NavBar,
    Goods
  }
};
</script>>



// WEBPACK FOOTER //
// src/pages/market/marketGoods/addGoods.vue